import { CircleSlash } from 'lucide-react';

import { cn } from '@/lib/utils';

interface BadgeCancelamentoPedidoProps {
  tamanho?: 'sm' | 'md';
  className?: string;
}

/**
 * Sinal de que a UBS pediu o cancelamento e ninguém decidiu ainda.
 *
 * Mesma forma dos badges de status, pela mesma razão do selo de documento
 * novo: na fila, o olho procura a etiqueta arredondada. Aqui a pressa é maior
 * — enquanto o pedido não é decidido, uma vaga continua presa a quem já avisou
 * que não vai comparecer.
 */
export function BadgeCancelamentoPedido({
  tamanho = 'md',
  className,
}: BadgeCancelamentoPedidoProps) {
  const descricao = 'A UBS pediu o cancelamento e a decisão está pendente.';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap',
        'border-status-cancelado-borda bg-status-cancelado-fundo text-status-cancelado-texto',
        tamanho === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        className,
      )}
      title={descricao}
    >
      <CircleSlash
        className={tamanho === 'sm' ? 'size-3' : 'size-3.5'}
        aria-hidden="true"
        strokeWidth={2.25}
      />
      <span>Cancelamento pedido</span>
      <span className="apenas-leitor-tela">. {descricao}</span>
    </span>
  );
}
